<template>
  <div class="top-banner">
      <img src="@/assets/topbanner.jpg" alt="华洲电力" class="banner-img" />
  </div>
  <div class="about-container">
    <div class="about-content">
      <!-- 标题区域 -->
      <div class="title-section">
        <h1>关于华洲电力</h1>
        <div class="title-line"></div>
      </div>
      
      <!-- 公司简介和图片区域 -->
      <div class="company-intro">
        <div class="company-image">
          <img src="@/assets/001.jpg" alt="华洲电力办公楼" class="office-building" />
        </div>
        <div class="company-text">
          <p>华洲电力建设有限公司成立于2019年，位于湖南湘乡经济开发区大将北路30号，注册资本人民币10158万元。是一家专注于电力工程施工，新能源工程投资与建设的现代化建筑企业。</p>
          <p>公司获得国家能源局湖南监管办颁发的承装（修、试）二级资质，省建设厅颁发的《安全生产许可证》、施工总承包电力工程贰级、市政公用工程贰级、建筑工程贰级、专业承包消防设施工程贰级、防水防腐保温工程贰级、电子与智能化工程贰级、地基基础工程贰级、起重设备安装工程贰级、古建筑工程贰级、输变电工程贰级，环保工程贰级、施工劳务不分等级、模板脚手架专业承包不分等级资质。</p>
          <p>公司取得了ISO9001质量管理体系认证证书、ISO14001环境管理体系认证证书、ISO45001职业健康安全管理体系认证证书。自成立以来连续多年荣获湖南省信用等级AAA企业、湘潭市守合同重信用单位、湖南省守合同重信用单位、湖南省电力企业协会会员单位、湘乡市电力工程企业协会会员单位。近年来在市委市政府的正确领导下公司认真贯彻落实市委市政府决策部署，扎实工作，锐意进取，荣获了湘乡市人民政府颁发的湘乡市建筑行业对外开拓先进单位，湘乡市民营企业税收贡献先进单位。</p>
          <p>为实现抱团取暖、借船出海、资源整合、互利共赢的发展愿景，华洲电建以"以质量赢得信誉，以信誉拓展市场"的经营思想，采用抱团机制、分享机制、发展机制，提供共创、共享、共赢的众创空间平台。目前公司业务已进驻湖南、广东、广西、贵州、江西、重庆、浙江、福建、安徽、黑龙江、湖北、内蒙古、宁夏、海南等省份，并开设了温州分公司、武汉分公司、蚌埠分公司、万安县分公司、杭州分公司、肇庆分公司、江西分公司、黔东南分公司、黑龙江分公司、梅州分公司等，以及全国各地十余个办事处。</p>
          <p>华洲电建将始终以客户为中心、专业专注、持续改进的核心价值观和"诚信、创新、超越、共赢"的企业精神，坚持精工良建、品臻致远，积极履行社会责任，打造政府、业主认可，职工、社会满意的和谐企业，努力创造价值、回馈社会。</p>
        </div>
      </div>
      
      <!-- 组织架构图区域 -->
      <div class="structure-section">
        <h1>组织架构图</h1>
        <div class="title-line"></div>
        <div class="structure-container">
          <img src="@/assets/structure.jpg" alt="组织架构图" class="structure-img" />
        </div>
      </div>
      
    </div>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head'

// SEO Meta标签配置
useHead({
  title: '关于华洲电力 - 专业电力工程建设公司',
  meta: [
    {
      name: 'description',
      content: '华洲电力建设有限公司成立于2019年，是一家专注于电力工程施工、新能源工程投资与建设的现代化建筑企业，拥有多项专业资质和认证。'
    },
    {
      name: 'keywords',
      content: '华洲电力,电力工程公司,电力施工,新能源工程,企业资质,组织架构'
    },
    {
      name: 'author',
      content: '华洲电力建设有限公司'
    },
    {
      property: 'og:title',
      content: '关于华洲电力 - 专业电力工程建设公司'
    },
    {
      property: 'og:description',
      content: '华洲电力建设有限公司成立于2019年，是一家专注于电力工程施工、新能源工程投资与建设的现代化建筑企业，拥有多项专业资质和认证。'
    },
    {
      property: 'og:type',
      content: 'website'
    }
  ]
})
</script>

<style scoped>
/* 基础样式 */
.about-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

/* 顶部banner样式 */
.top-banner {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: auto;
  display: block;
}

/* 内容区域 */
.about-content {
  padding: 20px;
}

/* 标题样式 */
.title-section {
  text-align: center;
  margin: 30px 0;
}

.title-section h1 {
  font-size: 2.4rem;
  color: #2c3e50;
  margin-bottom: 15px;
  font-weight: 300;
}

.title-line {
  width: 80px;
  height: 3px;
  background-color: #3f5ff0;
  margin: 0 auto;
}

/* 主内容布局 */
.main-grid {
  display: flex;
  gap: 30px;
  margin-top: 40px;
}

.grid-left {
  flex: 2;
}

.sidebar {
  flex: 1;
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

/* 公司简介区域 */
.company-section {
  display: flex;
  gap: 40px;
  margin-bottom: 50px;
}

/* 公司简介并排布局 */
.company-intro {
  display: flex;
  gap: 20px;
  margin: 40px 0;
  align-items: flex-start;
}

.company-image {
  width: 50%;
  height: 100%;
}

.company-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.company-text {
  width: 50%;
}

.company-text p {
  font-size: 0.8rem;
  line-height: 1.6;
  color: #555;
  text-align: justify;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .company-intro {
    flex-direction: column;
    gap: 20px;
  }
  
  .company-image {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
  }
}

.company-left {
  flex: 1;
}

.company-right {
  flex: 0 0 350px;
}

.company-left h2 {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #3f5ff0;
}

.company-left h3 {
  font-size: 1.4rem;
  color: #444;
  margin: 25px 0 15px 0;
}

.company-left p {
  font-size: 1rem;
  line-height: 1.8;
  color: #555;
  text-align: justify;
}

.office-building {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* 组织架构图样式 */
.structure-section {
  margin: 60px 0;
  text-align: center;
}
.structure-section h1 {
  font-size: 2.4rem;
  color: #2c3e50;
  margin-bottom: 15px;
  font-weight: 300;
}

.structure-title {
  width: 100%;
  background-color: #3f5ff0;
  padding: 10px 0;
  margin-bottom: 0;
}

.structure-title h2 {
  font-size: 1.8rem;
  color: #fff;
  margin: 0;
  padding: 0;
  font-weight: bold;
}

.structure-container {
  width: 100%;
  overflow-x: auto;
  padding: 40px 15px;
  background-color: #fff;
}

.structure-img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

/* 业务范围和技术团队 */
.business-section, .team-section {
  margin: 40px 0;
}

.business-section h2, .team-section h2 {
  font-size: 1.6rem;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #3f5ff0;
}

.business-section p, .team-section p {
  font-size: 1rem;
  line-height: 1.8;
  color: #555;
  text-align: justify;
}

/* 核心价值观 */
.values-section {
  margin: 50px 0;
}

.values-section h2 {
  font-size: 1.6rem;
  color: #333;
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 2px solid #3f5ff0;
  text-align: center;
}

.values-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.value-item {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #3f5ff0;
}

.value-item strong {
  font-size: 1.2rem;
  color: #3f5ff0;
  display: block;
  margin-bottom: 10px;
}

.value-item p {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
  text-align: justify;
}

/* 右侧边栏样式 */
.business-nav, .contact-info, .location-info {
  padding: 25px;
  border-bottom: 1px solid #e0e0e0;
}

.business-nav:last-child, .contact-info:last-child, .location-info:last-child {
  border-bottom: none;
}

.business-nav h3, .contact-info h3, .location-info h3 {
  font-size: 1.3rem;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 2px solid #3f5ff0;
}

.business-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.business-menu li {
  margin-bottom: 12px;
}

.business-menu a {
  color: #555;
  text-decoration: none;
  display: block;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s ease;
  background-color: #fff;
  border: 1px solid #e0e0e0;
}

.business-menu a:hover {
  background-color: #3f5ff0;
  color: #fff;
  border-color: #3f5ff0;
  transform: translateX(5px);
}

.contact-item {
  margin-bottom: 10px;
  font-size: 0.95rem;
  color: #555;
}

/* 地图样式 */
.map-wrapper {
  margin-top: 15px;
}

.map-container {
  width: 100%;
  height: 250px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* 底部页脚样式 */
.about-footer {
  background-color: #2c3e50;
  color: #fff;
  padding: 20px 0;
  margin-top: 40px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
}

.footer-info p {
  margin: 5px 0;
  font-size: 0.9rem;
  color: #ddd;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .main-grid {
    flex-direction: column;
  }

  .company-features, .two-grids, .value-cards {
    flex-direction: column;
  }

  .feature-card, .grid-item, .value-card {
    margin-bottom: 20px;
  }

  .feature-card:last-child, .grid-item:last-child, .value-card:last-child {
    margin-bottom: 0;
  }
  
  /* 响应式调整企业简介和图片布局 */
  .intro-with-image {
    flex-direction: column;
    gap: 20px;
  }
  
  .company-image {
    flex: 0 0 auto;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .about-header h1 {
    font-size: 1.8rem;
  }

  .about-container {
    padding: 15px;
  }

  .sidebar-section {
    padding: 15px;
  }
}
</style>